import type { IconData } from '@stacksjs/iconify-core'

export const to4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#c10000\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M0 0h250v200.3H0z\"/><g fill=\"#c10000\"><path d=\"M102.8 31.2h39.9v139.6h-39.8z\"/><path d=\"M192.6 81v40H53V81z\"/></g></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default to4x3
